/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
factory('BookingView', ["$log","BookingServiceView","Booking","BookingSrv","DayData","HumanResourceData","ServiceData","CustomerData","BookingData","CustomerView",
        "Period","DaySrv","Customer","PhysicalResourceData", "DayView" ,"SaleData","SaleView","BookingCreator", "BookingPartnerSettings", "BasicAuthRoleFactory",
        "BookingSettings", "BookingPartnerSettingsFactory",
    function ($log,BookingServiceView,Booking,BookingSrv,DayData,HumanResourceData,ServiceData,CustomerData,BookingData,CustomerView,
              Period,DaySrv,Customer,PhysicalResourceData,DayView,SaleData,SaleView,BookingCreator, BookingPartnerSettings, BasicAuthRoleFactory,
              BookingSettings, BookingPartnerSettingsFactory){

    var  BookingView = function (booking,bookingIndex,domainView)
    {
        this.bookingIndex = bookingIndex;
        this.label = null;
        this.domainView = domainView;
        this.price =0;
        this.creator = BookingCreator.WEBSITE.key;
        this.customerView = null;
        this.period = new Period();//period of booking
        this.itnDurationD=0;//displayed
        this.date = null;
        this.aDayView = null;
        this.status = "created";
        this.bookingServicesView=[];
        this.customerComment ="";
        this.saleView = null;
        this.hasSale = false;
        if (booking)
            this.loadDataFrom(booking);
        else
            this.date = new Date();
        this.basicAuthRoleFactory = BasicAuthRoleFactory;
        this.bookingSettings = BookingSettings;
    };

    BookingView.prototype.copyDataTo = function(booking)//
    {
        booking.setPeriod(this.period);
        booking.label = this.label;
        booking.price = this.price;
        booking.status = this.status;
        booking.creator = this.creator;
        if (this.customerComment && this.customerComment !== "")
            booking.comment = "Commentaire du client : \n\"" + this.customerComment + "\"";
        if (this.customerView)
        {
            booking.customer = this.customerView.getModel();
            if (!booking.customer)
            {
                booking.customer = new Customer();
                this.customerView.copyDataTo(booking.customer);
            }
        }
        if (this.saleView)
            booking.sale =this.saleView.getModel();
        else
            booking.sale = null;


    };

    BookingView.prototype.loadDataFrom = function(booking)//
    {
        if (booking)
        {
            this.label = booking.label;
            this.price = booking.price;
            this.status = booking.status;
            this.creator = booking.creator;
            this.setPeriod(booking.period);
            this.hasSale = (booking._saleId!=null);
            if (booking.day)
                this.date = DaySrv.getDateFromId(booking.day.id);
            else
                this.date = new Date();
            if (booking.customer)
            {
                this.customerView = this.domainView.getCustomerView(booking.customer);

            }
            var bsV;
            this.bookingServicesView = [];
            for (var i=0;i<booking.bookingServices.length;i++)
            {
                bsV =new BookingServiceView(booking.bookingServices[i],i,this);
                this.bookingServicesView.push(bsV);
            }

            if (booking.sale)
            {
                var dayView = null;
                if (booking.sale.day)
                    dayView = new DayView(DayData.getIndexOf(booking.sale.day));
                this.saleView = new SaleView(booking.sale,SaleData.getIndexOf(booking.sale),dayView,this,this.domainView.ad.view);
            }
            else
                this.saleView = null;

            this.updateGlobalBookingDataFromBS();
        }
    };

    BookingView.prototype.moveToStart = function(start)
    {
        if (this.period)
        {
            var startTime = this.period.start.getTime();
            this.period.moveToStart(start)
            var updateTime = this.period.start.getTime() - startTime;
            for (var i=0;i<this.bookingServicesView.length;i++)
                this.bookingServicesView[i].addTime(updateTime) ;

        }
    };

    BookingView.prototype.isBookable = function (aDayView, aDayHrView) {
        let isBookable = true;
        let aListADayHrsView = aDayView.getADayHrsViewWithPeriod();//clone because reorder it.
        let aListADayPrsView = aDayView.getADayPrsViewWithPeriod();//clone because reorder it.
        for (let i = 0; i < this.bookingServicesView.length; i++) {
            isBookable = isBookable && this.bookingServicesView[i].isBookable(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
        }
        return isBookable;

    };

    BookingView.prototype.setPeriod = function(period)
    {
        if (period)
            this.period = new Period(period);
    };

    BookingView.prototype.setPeriodStart = function(start)
    {
        if (!this.period)
            this.period = new Period();
        this.period.setStart(start);
    };

    BookingView.prototype.setPeriodEnd = function(end)
    {
        if (!this.period)
            this.period = new Period();
        this.period.setEnd(end);
    };

    BookingView.prototype.setADayHrView = function(aDayHrView)
    {
        for (var i=0; i< this.bookingServicesView.length;i++)
            if (this.bookingServicesView[i].serviceView.nbHrsNeeded>0)
                this.bookingServicesView[i].aDayHrView = aDayHrView;
    };

    BookingView.prototype.setADayPrView = function(aDayPrView)
    {
        for (var i=0; i< this.bookingServicesView.length;i++)
            if (this.bookingServicesView[i].serviceView.nbPrsNeeded>0)
                this.bookingServicesView[i].aDayPrView = aDayPrView;
    };

    BookingView.prototype.getBookingServiceViewById = function(id)
    {
        var bs;
        for (var i=0; i< this.bookingServicesView.length;i++)
        {
            bs =this.bookingServicesView[i].getModel();
            if (bs && bs.id==id)
                return this.bookingServicesView[i];
        }
        return null;
    };


    BookingView.prototype.removeModel = function(successFunction, errorFunction)
    {
        var booking = this.getModel();
        if (booking)
        {
            BookingSrv.remove(booking, successFunction, errorFunction); // remove from model
            this.customerView.removeBookingView(this);//remove from view
        }
    };

    BookingView.prototype.reloadModel = function()
    {
        var booking = this.getModel();
        if (booking)
        {
            this.loadDataFrom(booking);

        }
    };

    BookingView.prototype.getModel = function()
    {
        if (this.bookingIndex !== -1)
            return BookingData.getByIndex(this.bookingIndex);
        return null;
    };

    BookingView.prototype.updateModel = function(successFunction,errorFunction)
    {
        if (this.bookingServicesView.length === 0 || !this.aDayView)//delete it
            alert("error : no services to save or day not set");
        else
        {

            let day = this.aDayView.getModel();
            let booking;
            if (this.bookingIndex === -1) // creation
            {
                booking = new Booking(null,day);
                this.bookingIndex = BookingData.getIndexOf(booking)
            }
            else
                booking = this.getModel();
            this.copyDataTo(booking);

            booking.bookingServices = [];
            for (let i=0;i<this.bookingServicesView.length;i++)
                this.bookingServicesView[i].updateModel(true);

            if (this.saleView)
                this.saleView.initModel();
            BookingSrv.onlineSave(booking,successFunction,errorFunction);
        }
        return true;
    };
    BookingView.prototype.hasService = function(serviceView)
    {
        for (var i=0;i<this.bookingServicesView.length;i++)
            if (this.bookingServicesView[i].serviceView ===serviceView)
                return true;
        return false;
    };


    BookingView.prototype.updateGlobalBookingDataFromBS = function()
    {
        this.itnDurationD =0;
        if (this.bookingServicesView.length!=0 && this.bookingServicesView[0].period)
        {
            var start = this.bookingServicesView[0].period.start;
            var end = this.bookingServicesView[0].period.end;
            if (this.bookingServicesView[0].serviceView)
                this.itnDurationD +=this.bookingServicesView[0].serviceView.itnDurationD;
            for (var i=1; i< this.bookingServicesView.length;i++)
            {
                if ((this.bookingServicesView[i].period.start.getTime())  < (start.getTime()))
                    start = this.bookingServicesView[i].period.start;
                if ((this.bookingServicesView[i].period.end.getTime()) > (end.getTime()))
                    end = this.bookingServicesView[i].period.end;

                if (this.bookingServicesView[i].serviceView)
                    this.itnDurationD +=this.bookingServicesView[i].serviceView.itnDurationD;
            }
            this.setPeriodStart(start);
            this.setPeriodEnd(end);
        }
        else
        {
            this.setPeriodEnd(this.period.start);
        }
        this.price = 0;
        for (var i=0;i<this.bookingServicesView.length;i++)
            this.price+= this.bookingServicesView[i].price;

        if (this.saleView)
            this.saleView.calculateSaleFields();
    };
    BookingView.prototype.addBookingServiceView = function (bsView,endFunction) {
        var index = this.bookingServicesView.indexOf(bsView);
        if (index==-1)
        {
            this.bookingServicesView.push(bsView);
            bsView.bookingView=this;
            bsView.billPosition = this.bookingServicesView.length;

            //update booking price
            this.price += bsView.price;
            //change period start/end
            this.updateGlobalBookingDataFromBS();

            if (endFunction!==undefined)
                endFunction(bsView);

            this.domainView.$emit("bookingUpdated");
        }

    };
    BookingView.prototype.addServiceOnBookingOnUserSelectCureItem = function (cureItemToServiceView)
    {
        if (cureItemToServiceView && cureItemToServiceView.serviceView &&
            cureItemToServiceView.quantity > cureItemToServiceView.usedQuantity)
        {
            var bookingView = this;
            this.addServiceOnBooking(cureItemToServiceView.serviceView,
                function(bsView)
                {
                    bookingView.setCureUsageOnBookingServiceView(cureItemToServiceView,bsView);
                });
        }
    };

    BookingView.prototype.updateBookingsServicesFromCustomerCures = function (customerView)
    {
        if(this.bookingServicesView){
            for(var i = 0 ; i < this.bookingServicesView.length ; i++){

                if(this.bookingServicesView[i]){
                    var citsView = customerView.getFirstCureItemToServiceViewByServiceView(this.bookingServicesView[i].serviceView);
                    if(citsView)
                        this.setCureUsageOnBookingServiceView(citsView, this.bookingServicesView[i]);
                }
            }
        }
    };
    BookingView.prototype.setCureUsageOnBookingServiceView = function (cureItemToServiceView,bsView)
    {
        cureItemToServiceView.addUsageFromBookingServiceView(bsView);
        bsView.price = 0;
        bsView.bookingView.updateGlobalBookingDataFromBS();
    };
    BookingView.prototype.resetBillPosition = function () {
        //Todo order
        for (var i=0;i<this.bookingServicesView.length;i++)
            if (this.bookingServicesView[i].billPosition=i+1);
    };
    BookingView.prototype.addServiceOnBooking = function (serviceView,endFunction) {

        var bsView = new BookingServiceView(null,-1,this);
        bsView.period.moveToStart(this.period.end);
        bsView.setService(serviceView);//set activity end using service duration

        this.addBookingServiceView(bsView,endFunction);//add bs to booking view
        return bsView;
    };

    BookingView.prototype.removeServiceOnBooking = function (serviceView) {
        for (let i=this.bookingServicesView.length-1;i>=0;i--) {
            if (this.bookingServicesView[i].serviceView ===serviceView) {
                this.removeBookingServiceView(this.bookingServicesView[i],true);

                return;
            }
        }
    };
    BookingView.prototype.removeBookingServiceView = function (bsView,adjustNextBookings) {
        let index = this.bookingServicesView.indexOf(bsView);
        if (index === -1) {
            return;   //TODO raise error
        }
        let start = this.bookingServicesView[index].period.start;

        this.bookingServicesView.splice(index,1);
        if (adjustNextBookings) {
            let i = index;
            for (i;i<this.bookingServicesView.length;i++) {
                let bookingServiceView = this.bookingServicesView[i];
                bookingServiceView.moveToPeriodStart(start);
                for (let j = 0; j < bookingServiceView.subBsView.length; j++) {
                    let subBookingServiceView = bookingServiceView.subBsView[j];
                        subBookingServiceView.moveToPeriodStart(start);
                        start = subBookingServiceView.period.end;
                }
                start =  bookingServiceView.period.end;
            }
        }
        this.resetBillPosition();
        this.price -= bsView.price;
        this.updateGlobalBookingDataFromBS();

        this.domainView.$emit("bookingUpdated");
    };

    BookingView.prototype.getHumanResourcesViewWhoKnow = function (humanResourcesView) {
        var humanResourcesViewWhoKnow = [];
        var needHr = false;
        for (var j=0;j<this.bookingServicesView.length ;j++)
            if (this.bookingServicesView[j].serviceView && this.bookingServicesView[j].serviceView.nbHrsNeeded>0)
                needHr = true;
        if (needHr && humanResourcesView)
            for (var i=0;i<humanResourcesView.length;i++)
            {
                var knowAll = true;
                for (var j=0;j<this.bookingServicesView.length &&knowAll;j++)
                    if (!humanResourcesView[i].getModel().hasService(this.bookingServicesView[j].serviceView.getModel()))
                        knowAll = false;
                if (knowAll && humanResourcesViewWhoKnow.indexOf(humanResourcesView[i])==-1)
                    humanResourcesViewWhoKnow.push(humanResourcesView[i]);
            }
        return humanResourcesViewWhoKnow;
    }


    BookingView.prototype.isAvailableForSecondaries = function(aDayView,assignedADayHrView,assign)
    {
        for (var i=0;i<this.bookingServicesView.length;i++)
        {
            if (!this.bookingServicesView[i].isAvailableForSecondaries(aDayView,assignedADayHrView,assign))
                return false;
        }
        return true;
    }
        BookingView.prototype.canBook = function()//
        {
            if (this.bookingServicesView.length==0||!this.aDayView)
                return false;
            for (var i=0;i<this.bookingServicesView.length;i++)
            {
                if (!this.bookingServicesView[i].isPackage && (!this.bookingServicesView[i].serviceView ||
                    (!this.bookingServicesView[i].aDayHrView && !this.bookingServicesView[i].aDayPrView)))
                    return false;
            }
            return true;
        }
    BookingView.prototype.getProductsOfServices = function()//
    {
        let productsOfServicesView=[];
        for (let i=0;i<this.bookingServicesView.length;i++)
        {
            if (this.bookingServicesView[i].serviceView)
            {
                for (let j=0;j<this.bookingServicesView[i].serviceView.productsView.length;j++)
                    if (this.bookingServicesView.indexOf(this.bookingServicesView[i].serviceView.productsView[j]))
                        productsOfServicesView.push(this.bookingServicesView[i].serviceView.productsView[j]);
            }
        }
        return productsOfServicesView;
    };
    BookingView.prototype.getCureItemsService = function() {
        let cureItemServices = [];
        for (let i = 0; i <= this.bookingServicesView.length; i++) {
            let cureItem = new Object();
            if (this.bookingServicesView[i] && this.bookingServicesView[i].cureItemToServiceUsageView) {
                cureItem.cureItemId = this.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId;
                cureItem.serviceId = this.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.serviceId;
                cureItemServices.push(cureItem);
            }
        }
        return cureItemServices;
    };

    BookingView.prototype.checkBookingSettings = function (setting) {
        return BookingPartnerSettingsFactory.checkBookingPartnerSettings(setting, this.creator);
    };

    return BookingView;
}]);


// WEBPACK FOOTER //
// ./js/services/customerSite/views/BookingView.js